/******** quickcart.js ********/
class QuickCart {
	promoProps: PromoProps;
	elementIDs: ElementIDs;
	lightboxProps: LightboxProps;
	hasSubInCartNote: string;
	cartItems: [CartItems?];
	constructor({
	  promoProps,
	  elementIDs,
	  lightboxProps,
	  hasSubInCartNote,
	  cartItems
	}) {
	  const defaultElementIds = {
		lightboxCart: {
		  lbSumQty: '#lbSumQty',
		  lbCashSubtotal: '#lbCashSubtotal',
		  lbPointsSubtotal: '#lbPointsSubtotal',
		  lbItemContainerPrefix: '#lbItem',
		  lbImagePrefix: '#lbImage',
		  lbProdNamePrefix: '#lbProdName',
		  lbCurrentPricePrefix: '#lbCurrentPrice',
		  lbCurrentPointsPrefix: '#lbCurrentPoints',
		  lbListPricePrefix: '#lbListPrice',
		  lbListPointsPrefix: '#lbListPoints',
		  lbExtPrefix: '#lbExt',
		  lbQtyPrefix: '#lbQty'
		},
		headerCart: {
		  cartSumQty: '#cartSumQty',
		  bubbleCnt: '#bubble-cnt',
		  labelAux: '#labelAux',
		  DIVitemHead: '#DIVitemHead',
		  DIVcartSumItemsList: '#DIVcartSumItemsList',
		  DIVNoItem: '#DIVNoItem',
		  ulMarkupDIVcartSumItemsList: '<ul><li class="Qty"></li><li class="ItemDescr"></li><li class="Price price-cash"></li><li class="Price price-points"></li></ul>',
		  hdCashSubtotal: '#hdCashSubtotal',
		  hdPointsSubtotal: '#hdPointsSubtotal',
		  hdPointsSubtotalDiscount: '#hdPointsSubtotalDiscount',
		  hdQtyClass: '.Qty',
		  hdItemDescrClass: '.ItemDescr',
		  hdCashClass: '.price-cash',
		  hdPointsClass: '.price-points',
		}
	  };
	  this.promoProps = promoProps || {};
	  this.elementIDs = {
		...defaultElementIds,
		...elementIDs
	  };
	  this.lightboxProps = lightboxProps;
	  this.hasSubInCartNote = hasSubInCartNote;
	  this.cartItems = cartItems;
	}
	get _cartItems() {
	  return this.cartItems;
	}
	set _cartItems(newCartItems) {
	  this.cartItems=newCartItems;
	}
	getPromoValue(name: string): string {
	  return this.promoProps[name];
	}
	setPromoValue(name: string, value: string): void {
	  this.promoProps[name] = value;
	}
	populateItemUl(ct: number): void{
		let htmlString='';
		for (let i = 0; i < ct; i++) {
			htmlString+=this.lightboxProps.lbItemWrapUl.replace(/%K%/g,i.toString())
		}		
		if (this.lightboxProps.lbItemWrapAfterUl!=='') {htmlString+=this.lightboxProps.lbItemWrapAfterUl};
		$('#lbItemWrap').html(htmlString);
	}
	updateQuickCart(justAddedArray: JustAddedArray[], ajaxResults: string, productIndex: number, triggerElement?: HTMLElement): void {
	  if (ajaxResults !== '') {
		let sumCartQty = 0;
		const dsItemRowCount = getXMLDataTableRowCount('dsBasket', 1, ajaxResults);
		for (let i = 0; i < dsItemRowCount; i++) {
		  sumCartQty += parseInt(getXMLDataFieldValue('dsBasket', 1, i, 'qtyOrd', ajaxResults));
		}
		const bubbleCnt = $(this.elementIDs.headerCart.bubbleCnt);
		const labelAux = $(this.elementIDs.headerCart.labelAux);
		if (bubbleCnt.length) {
		  $(this.elementIDs.headerCart.cartSumQty).show();
		  bubbleCnt.html( sumCartQty.toString());
		  
		  labelAux.html(`${sumCartQty.toString()} ${sumCartQty.toString() === '1' ? "item" : "items"}`);
		}
		this.populateItemUl(justAddedArray.length);
		for (let ct = 0; ct < this.lightboxProps.numItemContainer; ct++) {
		  let lbItemContainer = $(`${this.elementIDs.lightboxCart.lbItemContainerPrefix}${ct}`);
		  if (justAddedArray.length > ct) {
			if (lbItemContainer.length) {
			  let lbItemImage = $(`${this.elementIDs.lightboxCart.lbImagePrefix}${ct}`);
			  let lbItemName = $(`${this.elementIDs.lightboxCart.lbProdNamePrefix}${ct}`);
			  let lbItemCurrentPrice = $(`${this.elementIDs.lightboxCart.lbCurrentPricePrefix}${ct}`);
			  let lbItemCurrentPoints = $(`${this.elementIDs.lightboxCart.lbCurrentPointsPrefix}${ct}`);
			  let lbItemListPrice = $(`${this.elementIDs.lightboxCart.lbListPricePrefix}${ct}`);
			  let lbItemListPoints = $(`${this.elementIDs.lightboxCart.lbListPointsPrefix}${ct}`);
			  let lbItemQty = $(`${this.elementIDs.lightboxCart.lbQtyPrefix}${ct}`);
			  lbItemImage.attr('src', justAddedArray[ct].image);
			  lbItemImage.attr('alt', justAddedArray[ct].descr);
			  lbItemName.html(justAddedArray[ct].descr);
			  if (justAddedArray[ct].extensionGroup !== '') {
				let tmpExtNameArray = justAddedArray[ct].extension.split(';');
				for (let x = 0; x < this.lightboxProps.maxNumExtenionPerItem; x++) {
				  if (tmpExtNameArray[x] !== '' && tmpExtNameArray[x] !== undefined) {
					$(`${this.elementIDs.lightboxCart.lbExtPrefix}${ct}-${x}`).html(tmpExtNameArray[x]);
				  } else {
					$(`${this.elementIDs.lightboxCart.lbExtPrefix}${ct}-${x}`).html('');
				  }
				}
			  }
			  if (justAddedArray[ct].invtID.toUpperCase().indexOf('SUB')===-1) {
				if (justAddedArray[ct].points !== justAddedArray[ct].listpoints) {
				  lbItemListPoints.html(`<span aria-hidden="false" class="only-readers">Regular price</span> ${formatPoints(justAddedArray[ct].listpoints)} Points`);
				  lbItemCurrentPoints.html(`<span aria-hidden="false" class="only-readers">Sale price</span> ${formatPoints(justAddedArray[ct].points)} Points`);
				} else {
				  lbItemListPoints.html('');
				  lbItemCurrentPoints.html(`${formatPoints(justAddedArray[ct].points)} Points`);
				}
			  } else {
				lbItemListPoints.html('');
				lbItemCurrentPoints.html('NA');
			  }
			  if (justAddedArray[ct].price !== justAddedArray[ct].listprice) {
				SalesforceAbandonedCartUtils.addCartOrOrderData({
				  item: justAddedArray[ct].itemID, 
				  quantity: justAddedArray[ct].qty, 
				  price: justAddedArray[ct].listprice, 
				  salePrice: justAddedArray[ct].price, 
				  uniqueId: justAddedArray[ct].invtID
				});
				lbItemListPrice.html(`<span aria-hidden="false" class="only-readers">Regular price</span> ${formatCurrency(justAddedArray[ct].listprice)}`);
				lbItemCurrentPrice.html(`<span aria-hidden="false" class="only-readers">Sale price</span> ${formatCurrency(justAddedArray[ct].price)}`);
			  } else {
				SalesforceAbandonedCartUtils.addCartOrOrderData({
				  item: justAddedArray[ct].itemID, 
				  quantity: justAddedArray[ct].qty, 
				  price: justAddedArray[ct].listprice, 
				  salePrice: undefined, 
				  uniqueId: justAddedArray[ct].invtID
				});
				lbItemListPrice.html('');
				lbItemCurrentPrice.html(formatCurrency(justAddedArray[ct].price));
			  }
			  if (justAddedArray[ct].qty !== '0' && justAddedArray[ct].qty !== '') {
				lbItemQty.html(justAddedArray[ct].qty);
			  }
			  lbItemContainer.show();
			}
		  } else {
			lbItemContainer.hide();
		  }
		}
		SalesforceAbandonedCartUtils.trackCart()
		//GA Remarketing
		try{trackATC(dsItemRowCount, ajaxResults, justAddedArray);}catch(e){console.log('track ATC error');}
		$(this.elementIDs.headerCart.DIVNoItem).hide();
		$(this.elementIDs.headerCart.DIVitemHead).show();
		$(this.elementIDs.headerCart.DIVcartSumItemsList).show();
		$(this.elementIDs.headerCart.DIVcartSumItemsList).html('');
		$(this.elementIDs.headerCart.DIVcartSumItemsList).append(`<span class="points-ui info-ui">${this.hasSubInCartNote}</span>`);
		for (let i = 0; i < dsItemRowCount; i++) {
		  $(this.elementIDs.headerCart.DIVcartSumItemsList).append(this.elementIDs.headerCart.ulMarkupDIVcartSumItemsList);
		  const currentBasketID = getXMLDataFieldValue('dsBasket', 1, i, 'basketID', ajaxResults);
		  const dsBasketExtensionsCount = getXMLDataTableRowCount('dsBasketExtensions', 0, ajaxResults);
		  let sumProdName = getXMLDataFieldValue('dsBasket', 1, i, 'Descr', ajaxResults);
		  sumProdName = sumProdName.replace('&lt;br&gt;', '<br>').replace('&lt;sup&gt;', '<sup>').replace('&lt;/sup&gt;', '</sup>');
		  let ItemDescrString = `<p><span>${sumProdName}</span>`;
		  for (let be = 0; be < dsBasketExtensionsCount; be++) {
			if (currentBasketID === getXMLDataFieldValue('dsBasketExtensions', 0, be, 'basketID', ajaxResults)) {
			  ItemDescrString += `<span>${getXMLDataFieldValue('dsBasketExtensions', 0, be, 'Descr', ajaxResults)}</span>`;
			}
		  }
		  ItemDescrString += '</p>';
		  $(`${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdItemDescrClass}`).html(ItemDescrString);
		  $(`${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdCashClass}`).html(formatCurrency(getXMLDataFieldValue('dsBasket', 1, i, 'CurySlsPrice', ajaxResults)));
		  if (getXMLDataFieldValue('dsBasket', 1, i, 'alternateID', ajaxResults).toUpperCase().indexOf('SUB')===-1){
			$(`${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdPointsClass}`).html(`${formatPoints(getXMLDataFieldValue('dsBasket', 1, i, 'User5', ajaxResults))} Points`);
		  } else {
			$(`${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdPointsClass}`).html('NA');
		  }
		  $(`${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdQtyClass}`).html(getXMLDataFieldValue('dsBasket', 1, i, 'QtyOrd', ajaxResults));
		}
		const lbSumQty = $(this.elementIDs.lightboxCart.lbSumQty);
		if (lbSumQty.length) {
		  let lbSumQtyString = `${parseInt(sumCartQty.toString())} item${(sumCartQty > 1 ? 's' : '')}`;
		  lbSumQty.html(lbSumQtyString);
		}
		const lbCashSubtotal = $(this.elementIDs.lightboxCart.lbCashSubtotal);
		if (lbCashSubtotal.length) {
		  lbCashSubtotal.html(formatCurrency(getXMLDataFieldValue('dsBasket', 0, 0, 'curyTotMerch', ajaxResults)));
		}
		const lbPointsSubtotal = $(this.elementIDs.lightboxCart.lbPointsSubtotal);
		if (lbPointsSubtotal.length) {
		  lbPointsSubtotal.html(`${formatPoints(getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults))} Points`);
		}
		const hdCashSubtotal = $(this.elementIDs.headerCart.hdCashSubtotal);
		if (hdCashSubtotal.length) {
		  hdCashSubtotal.html(formatCurrency(getXMLDataFieldValue('dsBasket', 0, 0, 'curyTotMerch', ajaxResults)));
		}
		const hdPointsSubtotal = $(this.elementIDs.headerCart.hdPointsSubtotal);
		if (hdPointsSubtotal.length) {
		  hdPointsSubtotal.html(`${formatPoints(getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults))} Points`);
		}
		const hdPointsSubtotalDiscount = $(this.elementIDs.headerCart.hdPointsSubtotalDiscount);
		if (hdPointsSubtotalDiscount.length) {
		  hdPointsSubtotalDiscount.html(`${formatPoints(getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults))} Points`);
		}
		if (this.promoProps.promoType !== undefined) {
		  if (this.promoProps.promoType.toUpperCase() === 'BMSM') {
			getBMSMTotals(ajaxResults, sumCartQty);
		  }
		}
		showElement('DIVcartbtns');
		showElement('overlay_LB');
		HAHAccessibility.trapFocus({
		  container: '.lbCartFocusTrap',
		  closeElement: '#overlay_LB', 
		  additionalCloseElements: ["#closeLbBtn"], 
		  tablistUpdateElements: [".cashTab", ".pointsTab"], 
		  triggerHTMLElement: triggerElement
		})
	  }
	  showHideLoader('hide', productIndex);
	}
	displayPromoTotals(toggledView: string): void {
	  if(this.getPromoValue('active')) {
		if (toggledView==='points'){
		  $('#lbCashSubtotalUL').hide();
		  $('#lbDiscountSummary').hide();
		  $('#lbPointsSubtotalUL').show();        
		  $('#hdULDiscount').hide();
		  $('#hdULNoDiscount').show();
		} else {
		  $('#lbCashSubtotalUL').hide();
		  $('#lbDiscountSummary').show();
		  $('#lbPointsSubtotalUL').hide();
		  $('#hdULDiscount').show();
		  $('#hdULNoDiscount').hide();
		}
	  }
	}
  }
  const quickCartObj = new QuickCart(classOptions);
  
  function parseXMLData(string: string): string | null {
	var parser = new DOMParser();
	var xmlDoc = parser.parseFromString('<root>' + string + '</root>', 'text/xml');
	var decodedContent = xmlDoc.documentElement.textContent;
	return decodedContent;
  }
  
  function trackATC(dsItemRowCount: number, ajaxResults: string, justAddedArray: JustAddedArray[]): void {
	let cartViewAdobeLaunch = []; // Adobe Launch 
	let cartProductsAW = []; // Google Remarketing
	let addToCartGA4=[]; //GA4 add-to-cart
	let newCartItems:[CartItems?]=[]; //new cartItems array post add-to-cart
	const dsItemExtensionCount = getXMLDataTableRowCount('dsBasketExtensions', 0, ajaxResults);
	const dsItemExtension=[];
	let tmpIndex=0;
	for (let i = 0; i < dsItemExtensionCount; i++) {    
	  dsItemExtension.push({
		basketID: getXMLDataFieldValue('dsBasketExtensions', 0, i, 'basketID', ajaxResults),
		sortIndex: parseInt(getXMLDataFieldValue('dsBasketExtensions', 0, i, 'sortIndex', ajaxResults)),
		extensionName: getXMLDataFieldValue('dsBasketExtensions', 0, i, 'name', ajaxResults)
	  });    
	}
	for (let i = 0; i < dsItemRowCount; i++) {
	  let matchedItem=quickCartObj._cartItems.find(item => item.invtID === getXMLDataFieldValue('dsBasket', 1, i, 'invtid', ajaxResults)&&item.altID === getXMLDataFieldValue('dsBasket', 1, i, 'alternateid', ajaxResults));
	  let addedQty=0;
	  if (matchedItem==undefined) {
		addedQty=parseInt(getXMLDataFieldValue('dsBasket', 1, i, 'qtyOrd', ajaxResults));
	  } else {
		let newQty=parseInt(getXMLDataFieldValue('dsBasket', 1, i, 'qtyOrd', ajaxResults));
		if (newQty>matchedItem.quantity) {addedQty=newQty-matchedItem.quantity};
	  }
	  let addedCategory = getXMLDataFieldValue('dsBasket', 1, i, 'categoryName', ajaxResults);
	  let addedCategoryID = getXMLDataFieldValue('dsBasket', 1, i, 'categoryID', ajaxResults);
	  let invtIDCategory={};
	  if (addedQty!==0){
		if(addedCategory === ''){
			let tempItemID = justAddedArray[0].itemID;
			addedCategory = classOptions.itemProps[tempItemID].categoryName;
			addedCategoryID = classOptions.itemProps[tempItemID].categoryID;
			//set current category to added items that's not in any category
			invtIDCategory={
			  invtID: getXMLDataFieldValue('dsBasket', 1, i, 'invtID', ajaxResults),
			  alternateID: getXMLDataFieldValue('dsBasket', 1, i, 'alternateID', ajaxResults),
			  category: parseXMLData(addedCategory),
			  categoryID: addedCategoryID
      }
		}
		let tmpVariant = '';
		const matchedItemExtension=dsItemExtension.filter(elem=>elem.basketID===getXMLDataFieldValue('dsBasket', 1, i, 'basketID', ajaxResults));
		if (matchedItemExtension!==undefined) {
		  matchedItemExtension.sort((a: { sortIndex: number; }, b: { sortIndex: number; }) => a.sortIndex - b.sortIndex);
		  tmpVariant=matchedItemExtension.map((item: { extensionName: string; }) => item.extensionName).join(';');
		}
		let GA4Obj={
		  item_name: parseXMLData(getXMLDataFieldValue('dsBasket', 1, i, 'Descr', ajaxResults)),
		  item_id: getXMLDataFieldValue('dsBasket', 1, i, 'itemid', ajaxResults),
		  affiliation: classOptions.affiliation,
		  price: parseFloat(getXMLDataFieldValue('dsBasket', 1, i, 'CurySlsPrice', ajaxResults)),
		  discount: (getXMLDataFieldValue('dsBasket', 1, i, 'itemid', ajaxResults).toUpperCase().indexOf('-SUB')!==-1)?0:Number((parseFloat(getXMLDataFieldValue('dsBasket', 1, i, 'CuryListPrice', ajaxResults))-parseFloat(getXMLDataFieldValue('dsBasket', 1, i, 'CurySlsPrice', ajaxResults))).toFixed(2)),
		  subscription: (getXMLDataFieldValue('dsBasket', 1, i, 'itemid', ajaxResults).toUpperCase().indexOf('-SUB')!==-1)?'yes':'no',
		  item_brand: classOptions.item_brand,
		  item_category: parseXMLData(addedCategory),
		  quantity: addedQty || 1,
		  index: tmpIndex,
		  item_list_id: parseXMLData(addedCategoryID),
			  item_list_name: parseXMLData(addedCategory)
		};
		if (tmpVariant!=='') GA4Obj['item_variant']=parseXMLData(tmpVariant);
		addToCartGA4.push(GA4Obj);
		tmpIndex++;
	  }
		//added basket-category mapping to localStorage as a workaround for items not in any category
    if (Object.keys(invtIDCategory).length !== 0){
			if (localStorage['invtid_category']!==''&&localStorage['invtid_category']!==undefined){
			  const invtIDCategoryArray=JSON.parse(localStorage['invtid_category']);    
			  const filteredArray = invtIDCategoryArray.filter((item: {invtID:string,alternateID:string}) => !(item.invtID === invtIDCategory.invtID && item.alternateID === invtIDCategory.alternateID));
			  if (filteredArray.length===0){
				  localStorage['invtid_category']=`[${JSON.stringify(invtIDCategory)}]`;
			  } else {
				  filteredArray.push(invtIDCategory);
				  localStorage['invtid_category']=JSON.stringify(filteredArray);
			  }
			} else {
			  localStorage['invtid_category']=`[${JSON.stringify(invtIDCategory)}]`;
			}
    }
	  newCartItems.push({
		invtID: getXMLDataFieldValue('dsBasket', 1, i, 'invtid', ajaxResults),
		altID:  getXMLDataFieldValue('dsBasket', 1, i, 'alternateid', ajaxResults),
		quantity: parseInt(getXMLDataFieldValue('dsBasket', 1, i, 'qtyOrd', ajaxResults))
	  });
	  cartViewAdobeLaunch.push({
		name: parseXMLData(getXMLDataFieldValue('dsBasket', 1, i, 'descr', ajaxResults)),
		sku: getXMLDataFieldValue('dsBasket', 1, i, 'invtid', ajaxResults),
		price: parseFloat(getXMLDataFieldValue('dsBasket', 1, i, 'CurySlsPrice', ajaxResults)).toFixed(2),
		quantity: getXMLDataFieldValue('dsBasket', 1, i, 'qtyOrd', ajaxResults) || 1,
		category: parseXMLData(getXMLDataFieldValue('dsBasket', 1, i, 'categoryname', ajaxResults))
	  });
	}
	quickCartObj._cartItems = newCartItems;
	for (let ct = 0; ct < justAddedArray.length; ct++) {    
	  cartProductsAW.push({
		id: justAddedArray[ct].itemID.replace('-SUB-12', '').replace('-SUB', ''),
		google_business_vertical: 'retail'
	  });
	}
	const mainItem={
	  id: justAddedArray[0].itemID,
	  name: justAddedArray[0].descr,
	  category: classOptions.itemProps[justAddedArray[0].itemID].categoryName,
	  value: Number(Number(justAddedArray[0].price)*Number(justAddedArray[0].qty)).toFixed(2)
	}
	let totalValue_AddToCart = Number((addToCartGA4.reduce((total: number, item: { price: number; quantity: number; discount: number}) => total + (item.price * item.quantity), 0)).toFixed(2));
	//GA4 add_to_cart
	dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
	dataLayer.push({
	  'event': 'add_to_cart',
	  'ecommerce': {
		'currency': 'USD',
		'value': totalValue_AddToCart,
		'items': addToCartGA4
	  },
	  'event_value': totalValue_AddToCart,
	  'event_items': cartProductsAW,
	  'mainItem': mainItem
	});
	//Adobe Launch
	dataLayer.cartView = {
	  products: cartViewAdobeLaunch,
	  totalCost: getXMLDataFieldValue('dsBasket', 0, 0, 'curyTotMerch', ajaxResults),
	  currencyCode: 'USD'
	};
  }
  
  /******* Interfaces *******/
  
  interface JustAddedArray {
	itemID: string;
	invtID: string;
	descr: string;
	image: string;
	extensionGroup: string;
	extension: string;
	price: string;
	listprice: string;
	points: string;
	listpoints: string
	qty: string;
  }
  
  interface ElementIDs {
	lightboxCart: {
	  lbSumQty: string;
	  lbSubtotal: string;
	  lbCashSubtotal: string;
	  lbPointsSubtotal: string;
	  lbItemContainerPrefix: string;
	  lbImagePrefix: string;
	  lbProdNamePrefix: string;
	  lbCurrentPricePrefix: string;
	  lbListPricePrefix: string;
	  lbCurrentPointsPrefix: string;
	  lbListPointsPrefix: string;
	  lbExtPrefix: string;
	  lbQtyPrefix: string;
	},
	headerCart: {
	  cartSumQty: string;
	  labelAux: string;
	  bubbleCnt: string;
	  DIVitemHead: string;
	  DIVcartSumItemsList: string;
	  DIVNoItem: string;
	  ulMarkupDIVcartSumItemsList: string;
	  hdItemDescrClass: string;
	  hdCashClass: string;
	  hdPointsClass: string;
	  hdQtyClass: string;
	  hdSubtotal: string;
	  hdQty: string;
	  hdItemDescr: string;
	  hdPrice: string;
	  hdCashSubtotal: string;
	  hdPointsSubtotal: string;
	  hdPointsSubtotalDiscount: string;
	}
}
  